import * as Actions from './actions/actions'
import reducer from './reducers/index'
import watch from 'redux-watch'
import { settings } from '../../../settings/settings-util'

export default class nextitModuleNormalizeLanguage {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;;
    }

    static getDefaultSettings()
    {
        return settings;
    }

    getReducer() {
         return reducer;
    }

    initialize(store) {
        this._store = store;

        let base = this._settings.stateLocations.Conversation.Base;
        let location = this._settings.stateLocations.Conversation.language;

        let watchStateLocation = `${base}.${location}`

        let watcher = watch(this._store.getState, watchStateLocation);
        this._store.subscribe(watcher((newVal, oldVal, objectPath) => {
            return this.verifyFormat(newVal);
        }));
    }

    verifyFormat(val) {

        if ( val.match(/[a-z][a-z]-[A-Z][A-Z]/g) !== null) {
            return;
        }

        let location = this._settings.stateLocations.Conversation.language;

        if ( val.match(/[a-z][a-z]_[A-Z][A-Z]/g) !== null) {
            let newVal = val.replace("_", "-");

            this._store.dispatch(Actions.setNormalizedLanguage(newVal, location));
            return;
        }

        this._store.dispatch(Actions.setNormalizedLanguage('en-US', location));
        return;
    }



}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/normalize-language/src/normalize-language.js